import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import InputUnstyled from '@mui/base/InputUnstyled'

import { getArticles } from "../utils/data/data";
import { Footer } from "../common/Footer";
import { Icons } from '../utils/Icons'
import megaLogo from '../assets/img/megago.svg'
import searchIcon from '../assets/img/search.svg'


export default function NotFoundPage() {
  let articles = getArticles();
  let [searchParams, setSearchParams] = useSearchParams();
  const [first, setfirst] = useState(false)

  return (
    <div className="appContainer">
      <div className="mainHeader">
        <Link to="/" className="mainLogo">
          <Icons path={megaLogo} className="megagoLogo" />
          <i></i>
          <h1>Centro de ayuda</h1>
        </Link>
        <div className="searchWrap">
          <InputUnstyled
            value={searchParams.get("filter") || ""}
            placeholder="¿Cómo podemos ayudarte?"
            className="searchBar"
            startAdornment={<Icons path={searchIcon} className="searchIcon" />}
            onChange={(event) => {
              let filter = event.target.value;
              if (filter) {
                setSearchParams({ filter });
                setfirst(true)
              } else {
                setSearchParams({});
                setfirst(false)
              }
            }}
          />
          {first && 
            <div className="searchResults">
              {articles.filter((articles) => {
                let filter = searchParams.get("filter");
                if (!filter) return true;
                let name = articles.title.toLowerCase();
                return name.includes(filter.toLowerCase());
              }).map((articles) => (
                <Link
                  className='buttonLink'
                  to={`/article/${articles.articleId}`}
                  key={articles.articleId}
                >
                  {articles.title}
                </Link>
              ))}
              <i>Sin resultados</i>
            </div>
          }
        </div>
      </div>

      <div className="mainWidth lostPage">
          <div>
            <p>Lo sentimos, la página que buscas no se encuentra disponible.</p>
            <span>Código de error 404</span>
          </div>
      </div>
      <Footer />
    </div>
  );
}